export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
